"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { RotateCcw } from "lucide-react";
import { recoverOrReport } from "@/components/error-boundary-utils";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // Auto-reload on stale-chunk failures (post-deploy); otherwise log it.
  useEffect(() => {
    recoverOrReport(error);
  }, [error]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-6 py-20 text-center">
      <span className="font-caveat text-6xl text-destructive/25 sm:text-7xl">
        Oops
      </span>
      <h2 className="mt-4 font-serif text-2xl font-semibold text-foreground sm:text-3xl">
        Something went wrong
      </h2>
      <p className="mt-3 max-w-sm text-sm leading-relaxed text-muted-foreground sm:text-base">
        We&apos;re sorry &mdash; an unexpected error occurred. Try again, or
        reload the page to fetch the latest version.
      </p>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row">
        <Button onClick={reset} size="lg" className="w-full sm:w-auto">
          <RotateCcw className="mr-2 h-4 w-4" />
          Try again
        </Button>
        <Button onClick={() => window.location.reload()} size="lg" variant="outline" className="w-full sm:w-auto">
          Reload page
        </Button>
      </div>
    </div>
  );
}
